import api from './apiClient';

export const fetchFromPickupCargoPlaces = async (payload?: any) => {
  const response = await api.post('/cargo_places/table', payload);
  return response.data;
};
